var OUTCOME_SCALE_TYPES;

OUTCOME_SCALE_TYPES = ['ordinal', 'ratioOrInterval'];

module.exports = {
  OUTCOME_SCALE_TYPES: OUTCOME_SCALE_TYPES
};
